import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { startSignalR } from "containers/App/_actions";
import { getDataset, getSettings } from "./_actions";

export function useDataset(id) {
    const dispatch = useDispatch();
    const currentDataset = useSelector((state) => state.dataset.currentDataset);

    useEffect(() => {
        if (id) {
            dispatch(getDataset(id));
        }
    }, [id, dispatch]);

    const hasCurrentDataset = currentDataset && currentDataset.details.id === id;

    return {
        dataset: hasCurrentDataset ? currentDataset.details : null,
        analyses: hasCurrentDataset ? currentDataset.analyses.sort((a) => a.name) : null,
        runs: hasCurrentDataset ? currentDataset.runs : null,
    };
}

export function useScienceSettings() {
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.dataset.settings);
    const { accountId: orgIdFromQueryString } = useParams();
    const orgIdOfLoggedInUser = useSelector((state) => state.auth.accountId);

    useEffect(() => {
        if (!settings || settings.organisationId !== (orgIdFromQueryString || orgIdOfLoggedInUser)) {
            dispatch(getSettings(orgIdFromQueryString || orgIdOfLoggedInUser));
        }
    }, [orgIdFromQueryString, orgIdOfLoggedInUser, settings, dispatch]);

    return settings;
}

export function useServerNotifications() {
    const dispatch = useDispatch();
    const serverNotification = useSelector((state) => state.dataset.serverNotification);

    useEffect(() => {
        dispatch(startSignalR());
    }, [dispatch]);

    return serverNotification;
}
